/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const role = currentUser?.role;

  return {
    canAdmin: role === 'admin' || role === 'civil_admin',
    // 明确排除 civil_admin 对 AI统计 和 图片同步 的访问权限
    canAccessAIStats: role === 'admin' && (role as string) !== 'civil_admin',
    canAccessImageSync: role === 'admin' && (role as string) !== 'civil_admin',
  };
}